var patternRegExs = {};

module.exports = function ($) {

  /**
   * Validates the value of an input against the pattern
   * attribute if it is present
   *
   * @return bool
   */
  $.fn.swValidatePattern = function () {
    var $el = $(this);
    var pattern = $el.attr('pattern');
    var val = $el.val();

    if (!pattern) {
      return true;
    }

    patternRegExs[pattern] = patternRegExs[pattern] || new RegExp(pattern);
    return patternRegExs[pattern].test(val);
  };

  /**
   * Validates the value of an input against the minlength or maxlength
   * attribute if they are present
   *
   * @return boolean
   */
  $.fn.swValidateLength = function () {
    var $el = $(this);
    var min = $el.attr('minlength');
    var max = $el.attr('maxlength');
    var val = $el.val();

    if (min && (parseInt(min, 10) > val.length)) {
      return false;
    }

    if (max && (parseInt(max, 10) < val.length)) {
      return false;
    }

    return true;
  };
};
